import type { FeatureRoute } from '../types';
import { ContactDetailPage } from './ContactDetailPage';
import { ContactListPage } from './ContactListPage';
import { StatementPage } from './StatementPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'customers', element: <ContactListPage key="customer" kind="customer" /> },
  { path: 'customers/:id', element: <ContactDetailPage key="customer" kind="customer" /> },
  { path: 'customers/:id/statement', element: <StatementPage kind="customer" /> },
  { path: 'suppliers', element: <ContactListPage key="supplier" kind="supplier" /> },
  { path: 'suppliers/:id', element: <ContactDetailPage key="supplier" kind="supplier" /> },
  { path: 'suppliers/:id/statement', element: <StatementPage kind="supplier" /> },
];
